import {memoize} from '@servicenow/ui-utils';
import {
	AMB_GC,
	GQL_CACHE_CAPACITY,
	GQL_CACHING_ENABLED,
	HTTP_CACHE_CAPACITY,
	HTTP_CACHING_ENABLED,
	DISABLE_GQL_BATCHING,
	DISABLE_REST_BATCHING,
	ENABLE_ACTION_DISPATCHED_HANDLING,
	GARBAGE_COLLECTOR_INTERVAL,
	INTERSECT_ROOT_MARGIN,
	VALIDATE_SCHEMAS,
	CHECK_FOR_POSSIBLE_PRESENTATIONAL_COMPONENTS,
	POSSIBLE_PRESENTATIONAL_COMPONENTS,
	LOGGING_ENABLED,
	LOGGING_LEVELS,
	LOGS_OBSERVER_INTERVAL,
	LOGS_CLEANUP_INTERVAL,
	MEMOIZE,
	METRICS_LEVEL,
	METRICS_OBSERVER_INTERVAL,
	METRICS_TYPES,
	QUEUE_FLUSH_ENABLED,
	TELEMETRY_MARKING_ENABLED,
	TIME_TO_WAIT_AFTER_DISCONNECT,
	ENABLE_SCHEDULER_STATS,
	METRICS_COMPONENT_INTERACTIVE_ENABLED,
	ARIA_LIVE_ASSERTIVE_TIMEOUT,
	ARIA_LIVE_POLITE_TIMEOUT,
	WHEN_COMPONENT_IS_IDLE_TIMEOUT,
	WHEN_COMPONENT_IS_IDLE_THROTTLE,
	WHEN_COMPONENT_IS_IDLE_MIN_INTERVAL,
	SCHEDULER_RAF_TIMEOUT,
	METRICS_MARK_PRUNING_INTERVAL,
	METRICS_MARK_EXPIRATION,
	METRICS_PRUNE_MARKS
} from '../constants';

export const prodConfig = {};

// AMB GC
prodConfig[AMB_GC] = {};
prodConfig[AMB_GC][GARBAGE_COLLECTOR_INTERVAL] = 5000;
prodConfig[AMB_GC][TIME_TO_WAIT_AFTER_DISCONNECT] = 1000;

// Caching
prodConfig[GQL_CACHING_ENABLED] = false;
prodConfig[GQL_CACHE_CAPACITY] = 200;
prodConfig[HTTP_CACHING_ENABLED] = false;
prodConfig[HTTP_CACHE_CAPACITY] = 200;

// Request Batching
prodConfig[DISABLE_GQL_BATCHING] = false;
prodConfig[DISABLE_REST_BATCHING] = false;

// Memoize
prodConfig[MEMOIZE] = memoize;

// Validation
prodConfig[VALIDATE_SCHEMAS] = false;
prodConfig[CHECK_FOR_POSSIBLE_PRESENTATIONAL_COMPONENTS] = false;
prodConfig[POSSIBLE_PRESENTATIONAL_COMPONENTS] = [];

// Metrics
//
// Heads up that these following 2 config values are a little tricky when
// unset:
// - When `metricTypes` is not defined, then fall back to checking `metricsLevel`
// - When `metricsLevel` is not defined, then nothing is marked
prodConfig[METRICS_TYPES] = null;
prodConfig[METRICS_LEVEL] = null;
prodConfig[METRICS_OBSERVER_INTERVAL] = 3000;
prodConfig[ENABLE_SCHEDULER_STATS] = false;
prodConfig[TELEMETRY_MARKING_ENABLED] = true;

// Custom Event Dispatching
prodConfig[ENABLE_ACTION_DISPATCHED_HANDLING] = false;

// Intersection Observer
prodConfig[INTERSECT_ROOT_MARGIN] = '500px';

// Queue Flush Enabled
prodConfig[QUEUE_FLUSH_ENABLED] = false;

// Logging
prodConfig[LOGGING_ENABLED] = false;
prodConfig[LOGGING_LEVELS] = null;
prodConfig[LOGS_OBSERVER_INTERVAL] = 1000;
prodConfig[LOGS_CLEANUP_INTERVAL] = 60000;

prodConfig[METRICS_COMPONENT_INTERACTIVE_ENABLED] = false;

prodConfig[ARIA_LIVE_ASSERTIVE_TIMEOUT] = 500;
prodConfig[ARIA_LIVE_POLITE_TIMEOUT] = 5000;

prodConfig[WHEN_COMPONENT_IS_IDLE_TIMEOUT] = 5000;
prodConfig[WHEN_COMPONENT_IS_IDLE_THROTTLE] = 50;
prodConfig[WHEN_COMPONENT_IS_IDLE_MIN_INTERVAL] = 25;

prodConfig[SCHEDULER_RAF_TIMEOUT] = 0;

prodConfig[METRICS_MARK_PRUNING_INTERVAL] = 300000;
prodConfig[METRICS_MARK_EXPIRATION] = 300000;
prodConfig[METRICS_PRUNE_MARKS] = true;
